import { isCheckGameResultRecordsHasLotteryParticipant } from 'config/promoGameTypes';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { isLocalSameDateInPromoTimezone, utcDTStr2TimezoneDTStr } from 'utils/dateTime';

export default function useHasReachPlayTimesLimit() {
    const { totalPlayTimes, dailyPlayTimes, timezone } = useSelector(s => s.settingPromo);
    const { type: promoType } = useSelector(s => s.promo);
    const { periodPlayMatchedInfo: { isPeriodPlayMode, matchedInfo } = {} } = useSelector(
        s => s.promoState
    );

    const userGameResultRecords = useSelector(s => s.userGameResultRecords);
    const hasReachPlayLimit = useMemo(() => {
        const gameResultRecords = userGameResultRecords || [];
        const filteredRecords = gameResultRecords.filter(
            record => record.flow?.lotteryParticipant !== undefined
        );
        const filterGameResultRecords = isCheckGameResultRecordsHasLotteryParticipant(promoType)
            ? filteredRecords
            : gameResultRecords;
        return isPeriodPlayMode
            ? checkHasReachPeriodPlayLimit({
                  gameResultRecords: filterGameResultRecords,
                  timezone,
                  totalPlayTimes,
                  matchedInfo
              })
            : checkHasReachPlayLimit({
                  gameResultRecords: filterGameResultRecords,
                  timezone,
                  totalPlayTimes,
                  dailyPlayTimes
              });
    }, [
        userGameResultRecords,
        promoType,
        isPeriodPlayMode,
        timezone,
        totalPlayTimes,
        matchedInfo,
        dailyPlayTimes
    ]);
    return hasReachPlayLimit;
}

export function checkHasReachPeriodPlayLimit({
    totalPlayTimes,
    timezone,
    matchedInfo = {},
    gameResultRecords
}) {
    if (Number.isInteger(totalPlayTimes) && gameResultRecords.length >= totalPlayTimes) {
        return true;
    }
    if (!matchedInfo.match) {
        return true;
    }
    const played = gameResultRecords.filter(e => {
        const { flow: { gameResult: createdAt } = {} } = e;
        const timezoneDateStr = utcDTStr2TimezoneDTStr(createdAt, timezone);
        return (
            matchedInfo.periodStartInTZ <= timezoneDateStr &&
            timezoneDateStr <= matchedInfo.periodEndInTZ
        );
    });
    return played.length >= 1;
}

export function checkHasReachPlayLimit({
    gameResultRecords,
    timezone,
    totalPlayTimes,
    dailyPlayTimes
}) {
    if (Number.isInteger(totalPlayTimes) && gameResultRecords.length >= totalPlayTimes) {
        return true;
    }
    if (Number.isInteger(dailyPlayTimes)) {
        const todayPlayedEntries = gameResultRecords.filter(e => {
            const { flow: { gameResult: createdAt } = {} } = e;
            return isLocalSameDateInPromoTimezone(createdAt, timezone);
        }).length;
        if (todayPlayedEntries >= dailyPlayTimes) {
            return true;
        }
    }
    return false;
}
